// components/Footer.js
import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  const navigate = useNavigate();

  const quickLinks = [
    { id: 1, label: 'Home', type: 'top', to: '/' },
    { id: 2, label: 'Services', type: 'section', to: 'services' },
    { id: 3, label: 'AboutUs', type: 'section', to: 'about' },
    { id: 4, label: 'Contact', type: 'section', to: 'contact' },
    { id: 5, label: 'Terms & Conditions', type: 'route', to: '/terms-conditions' },     // ✅ updated
    { id: 6, label: 'Privacy Policy', type: 'route', to: '/privacy-policy' },           // ✅ correct
    { id: 7, label: 'Partner Vendor Terms', type: 'route', to: '/terms-conditions-partner' },  
    { id: 8, label: 'Vendorprivacy', type: 'route', to: '/privacy-policy-partner' },     // ✅ updated
  ];

 
  const scrollToSection = (sectionId) => {
    const doScroll = () => {
      const el = document.getElementById(sectionId);
      if (el) {
        const offset = 80; // navbar height
        const top = el.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    };

    if (location.pathname === '/') {
      doScroll();
    } else {
      navigate('/');
      setTimeout(doScroll, 350);
    }
  };

 
  const goToTop = () => {
    if (location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate('/');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 350);
    }
  };


  const handleLinkClick = (e, link) => {
    if (link.type === 'section') {
      e.preventDefault();
      scrollToSection(link.to);
    } else if (link.type === 'top') {
      e.preventDefault();
      goToTop();
    }
   
  };

  return (
    <div className="footer-wrapper">
      <div className="footer-wave">
        <svg
          viewBox="0 0 1440 120"
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M0,64 C180,120 360,20 540,50 C720,80 900,130 1080,90 C1260,50 1380,80 1440,60 L1440,120 L0,120 Z"
            className="footer-wave-path"
          />
        </svg>
      </div>

      <footer className="footer">
        <div className="footer-container">
          <div className="footer-grid">
            <div className="footer-brand">
              <Link to="/" className="footer-logo-link">
                <img
                  src="/img/footerlogo.png"
                  alt="QSlot Logo"
                  className="footer-logo"
                />
              </Link>
              <p className="footer-description">
                Your all-in-one booking platform for Car Wash, Turf, and
                Tournaments. Book instantly, anytime, anywhere.
              </p>

              <div className="footer-social">
                <a
                  href="https://www.facebook.com/share/18jkB6Fmqs/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                  className="footer-social-icon"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c5.05-.5 9-4.76 9-9.95z" />
                  </svg>
                </a>
                <a
                  href="https://www.instagram.com/qslot_?igsh=MW8wY2YxeGQ1eGo1Yw"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                  className="footer-social-icon"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                  </svg>
                </a>
                <a
                  href="https://www.youtube.com/@QSLOT-OnlineBookingApp/videos"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="YouTube"
                  className="footer-social-icon"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                  </svg>
                </a>
              </div>
            </div>

            <div className="footer-links-grid">
              {quickLinks.map((link) => (
                <Link
                  key={link.id}
                  to={link.type === 'route' ? link.to : '/'}
                  className="footer-link"
                  onClick={(e) => handleLinkClick(e, link)}
                >
                  <span className="footer-link-dot"></span>
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div className="footer-divider"></div>

          <div className="footer-bottom">
            <p className="footer-copy">
              © {currentYear} <strong>QSlot</strong>. All rights reserved.
            </p>
            <p className="footer-made">
              Made with <span className="footer-heart">♥</span> in Coimbatore, Tamil Nadu
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;